package com.xtream.ui.platform

import androidx.compose.material3.windowsizeclass.ExperimentalMaterial3WindowSizeClassApi
import androidx.compose.material3.windowsizeclass.WindowSizeClass
import androidx.compose.material3.windowsizeclass.WindowWidthSizeClass
 import androidx.compose.runtime.Composable
import androidx.compose.ui.input.InputMode.Companion.Touch
import androidx.compose.ui.platform.LocalInputModeManager

@Composable

expect fun  calculateWindowSizeClass() : WindowSizeClass
@OptIn(ExperimentalMaterial3WindowSizeClassApi::class)
@Composable
fun AdaptiveContent(
    expandedContent: (@Composable ()->Unit)?=null,
    compactContent: (@Composable ()->Unit)?=null,
    touchAlwaysUseCompact: Boolean = true,

    ){
    val inputModeManager = LocalInputModeManager.current
    val isTouch = inputModeManager.inputMode == Touch

    if(touchAlwaysUseCompact && isTouch) {
        compactContent?.invoke()
    }
    else {
        val windowSizeClass = calculateWindowSizeClass()

        when (windowSizeClass.widthSizeClass) {
            /*WindowWidthSizeClass.Compact -> { *//* Phone UI *//* }
        WindowWidthSizeClass.Medium -> { *//* Foldable UI *//* }*/
            WindowWidthSizeClass.Expanded -> { /* Tablet / TV UI */
                expandedContent?.invoke()

            }

            else -> {
                compactContent?.invoke()
            }
        }
    }

}
 @Composable
fun <T> adaptiveValue(
    expandedValue: T?=null,
    compactValue: T?=null,
    default: T,

    ) : T {
     @OptIn(ExperimentalMaterial3WindowSizeClassApi::class)
     val windowSizeClass = calculateWindowSizeClass( )

    return when (windowSizeClass.widthSizeClass) {
        /*WindowWidthSizeClass.Compact -> { *//* Phone UI *//* }
        WindowWidthSizeClass.Medium -> { *//* Foldable UI *//* }*/
        WindowWidthSizeClass.Expanded -> { /* Tablet / TV UI */
            expandedValue?:default

        }
        else -> {
            compactValue?:default
        }
    }
}


@Composable
fun IfElseContent(
    condition: Boolean,
    ifContent: @Composable () -> Unit,
    elseContent: @Composable () -> Unit
) {
    if (condition) {
        ifContent()
    } else {
        elseContent()
    }
}